var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8769105,19.4847401 C21.0421514,19.6499466 21.0421514,19.917154 20.8769105,20.0823949 L20.0823949,20.8769105 C19.917154,21.0421514 19.6499466,21.0421514 19.4847401,20.8769105 L15.2167677,16.6089382 C15.1394173,16.5280859 15.0937212,16.4226174 15.0937212,16.3101108 L15.0937212,15.8460769 C13.8105211,16.9534961 12.1406032,17.6249651 10.3124826,17.6249651 C6.27302534,17.6249651 3,14.3519398 3,10.3124826 C3,6.27302534 6.27302534,3 10.3124826,3 C14.3519398,3 17.6249651,6.27302534 17.6249651,10.3124826 C17.6249651,12.1406032 16.9534961,13.8105211 15.8460769,15.0937212 L16.3101108,15.0937212 C16.4226174,15.0937212 16.5280859,15.1359154 16.6089382,15.2167677 L20.8769105,19.4847401 Z M10.3124826,15.9374692 C13.4203014,15.9374692 15.9374692,13.4203014 15.9374692,10.3124826 C15.9374692,7.20466374 13.4203014,4.68749598 10.3124826,4.68749598 C7.20466374,4.68749598 4.68749598,7.20466374 4.68749598,10.3124826 C4.68749598,13.4203014 7.20466374,15.9374692 10.3124826,15.9374692 Z",
    id: "search-icon",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03ab9673.svg";
export { ForwardRef as ReactComponent };